module.exports = __webpack_public_path__ + "static/media/ind.b96b1262.jpg";